import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Footer from './components/Footer/Footer';
import './App.css';
import Publications from './components/Publications/Publications';
import Teaching from './components/Teaching/Teaching';
import Blog from './components/Blog/Blog';
import { ContentProvider } from './contexts/ContentContext';

const App: React.FC = () => {
  return (
    <ContentProvider>
      <LanguageProvider>
        <div className="app">
          <Navbar />
          <main>
            <Hero />
            <Publications />
            <Teaching />
            <Blog />
          </main>
          <Footer />
        </div>
      </LanguageProvider>
    </ContentProvider>
  );
};

export default App; 